export default __webpack_public_path__ + "static/chloe-signature-424bc34803663cbb3e859eb6e71939e0.svg";